/* This file was generated automatically. Do not edit manually. */

export enum BookingEngineTaxMessage {
    None = 'None',
    Vat = 'Vat',
    VatAndCityTax = 'VatAndCityTax',
    CityTax = 'CityTax',
    Fees = 'Fees',
    VatAndFees = 'VatAndFees',
    CityTaxAndFees = 'CityTaxAndFees',
    VatAndCityTaxAndFees = 'VatAndCityTaxAndFees',
}
